import { FC, useEffect, useState } from "react"
import { Anchor } from "../../app/components/anchor"
import { BlokImage } from "../../storyblok"
import classNames from "classnames"
import LogoIcon from "../svgs/Logo"
import PremiumNavForm from "./navigation-form"
import useScreenSize from "@/hooks/useScreenSize"

const STICKY_OFFSET = 664
const MOBILE_STICKY_OFFSET = 1420
const PremiumNavbar: FC<{
  blok: {
    buttonLabel: string
    buttonLink: string
    stickyButtonLabel?: string
    image: BlokImage
    isSticky: boolean
    hasStickyForm: boolean
  }
}> = (props) => {
  const {
    buttonLabel = "GET PET TRANSPORTATION QUOTES",
    buttonLink = "/shipments/new",
    isSticky,
    hasStickyForm,
    stickyButtonLabel,
  } = props.blok
  const showOnDesktop = useScreenSize({ min: "mmd" })
  const [shouldStick, setShouldStick] = useState(false)

  useEffect(() => {
    if (!isSticky) return

    const onScroll = () => {
      setShouldStick(
        window.scrollY >=
          (showOnDesktop ? STICKY_OFFSET : MOBILE_STICKY_OFFSET),
      )
    }

    onScroll()

    window.addEventListener("scroll", onScroll, { passive: true })
    return () => window.removeEventListener("scroll", onScroll)
  }, [isSticky, showOnDesktop])
  const logoWidth = showOnDesktop ? "188px" : "168px"
  return (
    <nav
      id="premium-navbar"
      className="flex justify-center items-center w-full"
    >
      <div
        className={classNames(
          "max-w-[1400px] w-full px-4 md:py-4 mx-auto z-[99999] transition-transform duration-1000 ease-out will-change-transform",
          shouldStick
            ? "fixed top-0 bg-white shadow translate-y-0"
            : "relative",
        )}
      >
        <div
          className={classNames(
            "flex gap-1 md:gap-3 min-h-16 items-center",
            shouldStick && hasStickyForm
              ? "justify-center flex-col md:grid md:grid-cols-[210px_1fr] md:justify-between"
              : "flex justify-between",
          )}
        >
          <Anchor
            href="/"
            className="flex items-center px-1.5 hover:no-underline no-underline"
          >
            <LogoIcon width={logoWidth} />
          </Anchor>
          {hasStickyForm && shouldStick ? (
            <>
              {showOnDesktop ? (
                <div>
                  <PremiumNavForm
                    buttonLabel={stickyButtonLabel}
                    buttonLink={buttonLink}
                  />
                </div>
              ) : (
                <div className="py-2 w-full">
                  {" "}
                  <Anchor
                    href={buttonLink}
                    id="button"
                    className="w-full inline-block py-4 p-2 rounded-md uppercase text-center bg-blue7 hover:text-white focused:text-white md:mt-4 text-white text-md lg:text-base"
                  >
                    {stickyButtonLabel}
                  </Anchor>
                </div>
              )}
            </>
          ) : (
            <>
              {isSticky ? (
                <div
                  className={classNames(
                    "items-center space-x-4 hidden md:flex",
                  )}
                >
                  <Anchor
                    href={buttonLink}
                    className={classNames(
                      "w-full py-4 p-2 rounded-md uppercase text-center bg-blue7 hover:bg-blue-700 mt-4 text-white text-sm lg:text-base hover:text-white",
                      isSticky ? "p-2" : "p-4",
                    )}
                  >
                    {isSticky ? stickyButtonLabel : buttonLabel}
                  </Anchor>
                </div>
              ) : (
                <div
                  className={classNames(
                    "items-center space-x-4 hidden md:flex",
                  )}
                >
                  <Anchor
                    href={buttonLink}
                    className="text-xs sm:text-md md:text-[16px] uppercase border border-gray14 hover:no-underline text-center text-gray14 rounded-3xl px-1 py-1 lg:p-4"
                  >
                    {buttonLabel}
                  </Anchor>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </nav>
  )
}

export default PremiumNavbar
